/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateDocusignVerificationKeyInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateDocusignVerificationKeyMutationVariables = {
    input: CreateDocusignVerificationKeyInput;
};
export type CreateDocusignVerificationKeyMutationResponse = {
    readonly createDocusignVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type CreateDocusignVerificationKeyMutation = {
    readonly response: CreateDocusignVerificationKeyMutationResponse;
    readonly variables: CreateDocusignVerificationKeyMutationVariables;
};



/*
mutation CreateDocusignVerificationKeyMutation(
  $input: CreateDocusignVerificationKeyInput!
) {
  createDocusignVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateDocusignVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDocusignVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createDocusignVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDocusignVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDocusignVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateDocusignVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDocusignVerificationKeyMutation(\n  $input: CreateDocusignVerificationKeyInput!\n) {\n  createDocusignVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fc1f3128400e73fb36ac9d6f972a3ae0';
export default node;
